module.exports = __webpack_public_path__ + "img/loading.8aa1e0e6.gif";